(function(window) { var svs = window.svs || {}; svs.modules = svs.modules || []; if(svs.modules.indexOf('/modules/terms-integrity/assets/javascripts/models/terms-docs.js') >= 0) return;  svs.modules.push('/modules/terms-integrity/assets/javascripts/models/terms-docs.js'); 
(function(Backbone, svs) {
  'use strict';

  svs.terms_integrity.models.TermsDocs = svs.terms_integrity.models.Base.extend({
    initialize: function() {
      if (svs.terms_integrity.data && svs.terms_integrity.data.terms) {
        this.set({
          terms: svs.terms_integrity.data.terms || {},
          termsService: svs.terms_integrity.data.termsService || {}
        });
      } else {
        this.getDocumentsFromCMS('terms');
        this.getDocumentsFromCMS('termsService');
      }
    }
  });
})(Backbone, svs);

 })(window);